<template>
  <MoleculeEditionProductSatellitesIncludedList
    v-if="habilitada"
    tipo="ruleta"
  />
</template>

<script>
import configApp from '@/config'

/*
 | Ruleta se oculta hasta que el Droop este terminado, igual que Evaluaciones: ademas de la pestaña, la
 | URL directa vuelve a Juedroop, para que no se pueda armar un producto con Ruleta por la puerta de
 | atras. El backend tiene su propia puerta (RULETA_VENDIBLE), que es la que de verdad lo impide.
 */
export default {
  name: 'MoleculeEditionProductSatellitesIncludedRuleta',

  components: {
    MoleculeEditionProductSatellitesIncludedList: () =>
      import('@/components/molecules/MoleculeEditionProductSatellitesIncludedList')
  },

  computed: {
    habilitada () {
      return configApp.droopRuletaHabilitado === true
    }
  },

  created () {
    if (!this.habilitada) {
      this.$router.replace(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.satellitesIncluded.subject')}/${this.$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition')}`)
    }
  }
}
</script>
